import {
  PaymentCardInput,
  type PaymentInputProps,
} from "../../payment-card-input";
import type { FieldProps } from "./shared";

export function PaymentCardField({
  field,
  ...props
}: Omit<PaymentInputProps, "onChange"> & FieldProps) {
  return <PaymentCardInput {...props} onChange={field.handleChange} />;
}
